import { createContext } from 'react';

type TimePeriodContextType = {
  timePeriod: string;
  setTimePeriod: (period: string) => void;
};

const TimePeriodContext = createContext<TimePeriodContextType>({
  timePeriod: '60',
  setTimePeriod: (_period: string) => {},
});

export { TimePeriodContext };
